import { Suspense } from 'react'

import { AppLink, AppLinkProps } from '../AppLink'

export const Link = (props: AppLinkProps) => {
  return (
    <Suspense>
      <AppLink {...props} />
    </Suspense>
  )
}
